var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-offcanvas-content"},[_c('div',{staticClass:"StudentLayout"},[_c('message-component'),_c('page-header'),_c('main',[_vm._t("default")],2),_c('page-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }